module.exports = __webpack_public_path__ + "img/李梦.baaae82e.jpg";